export class SubmissionUtils {
  computeV2Value = (v1Value, type) => {
    const newValue = {
      // single: null,
      // multiple: null,
      // file: null,
    };

    if (!v1Value) newValue.single = '';
    else if (typeof v1Value === 'string' || v1Value instanceof String) newValue.single = v1Value;
    else if (typeof v1Value === 'number') newValue.single = String(v1Value);
    else if (Array.isArray(v1Value)) newValue.multiple = v1Value;
    else if (type && v1Value instanceof Object && type === 'inventory_field') newValue.inventory = v1Value;
    else if (v1Value instanceof Object) newValue.file = v1Value;
    else {
      console.error('Unexpected type from:', v1Value);
      newValue.single = JSON.stringify(v1Value);
    }

    return newValue;
  };

  computeTableValue = (v1TableValue, tableField) => {
    const newValue = {
      // single: null,
      // multiple: null,
      // file: null,
      // table: null,
    };
    if (!v1TableValue) {
      newValue.table = [];
      return newValue;
    }

    const newTableValue = [];

    v1TableValue.forEach((v1RowValues) => {
      const rowValue = [];

      v1RowValues.forEach((v1Value, columnIdx) => {
        const v2Value = {
          label: tableField.props.column_headers[columnIdx],
          value: this.computeV2Value(v1Value),
        };

        rowValue.push(v2Value);
      });
      newTableValue.push(rowValue);
    });

    newValue.table = newTableValue;

    return newValue;
  };

  transformV1toV2 = (v1Results, pages) => {
    const v2Results = [];
    pages.forEach((page, pgIndx) => {
      const pageResult = [];

      page.controls.forEach((ctrl, ctrlIdx) => {
        const v1Value = v1Results[pgIndx][ctrlIdx];
        // let v2Value;
        const v2Value =
          ctrl.type === 'table_field' ? this.computeTableValue(v1Value, ctrl) : this.computeV2Value(v1Value, ctrl.type);

        const newResult = {
          internal_id: ctrl.internal_id,
          label: ctrl.props.label ?? '',
          value: v2Value,
        };

        pageResult.push(newResult);
      });

      v2Results.push(pageResult);
    });

    return v2Results;
  };
}

export default {
  SubmissionUtils,
};
